import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=02aadcaf"
import script from "./WarningAlert.vue?vue&type=script&lang=js"
export * from "./WarningAlert.vue?vue&type=script&lang=js"
import style0 from "./WarningAlert.vue?vue&type=style&index=0&id=02aadcaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports